import axios from 'axios'
import { authHeader } from '../util/authHeader'

const baseUrl = process.env.VUE_APP_API_BASE_URL + '/api/v2/'

const config = {
    headers: {
      ...authHeader()
    }
  }

export const braintreeService = {
  getToken,
  canMakePayment,
  createTransaction,
  createTransactionIncBillingAddress
}

async function canMakePayment(payload) {
  return await axios
    .get(baseUrl + `payment/canMakePayment`,config)
    .then((response) => {
      return response.data;
    }).catch((error) => {
      if (error.response) {
        const data = error.response.data;
        throw data;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log('Error', error.message);
      }
      console.log(error.config);
    });
}

async function getToken () {
  return await axios
    .get(baseUrl + `payment/getClientToken`,config)
    .then((response) => {
      return response.data;
    }).catch((error) => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // console.log(error.response.data);
        // console.log(error.response.status);
        // console.log(error.response.headers);
        const data = error.response.data;
        throw data;
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }
      console.log(error.config);
    });
}

async function createTransaction (nonce, amount, customerId) {
  return await axios
    .post(baseUrl + `payment/createTransaction`, { nonce, amount, customerId },config)
    .then((response) => {
      return response.data;
    }).catch((error) => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // console.log(error.response.data);
        // console.log(error.response.status);
        // console.log(error.response.headers);
        const data = error.response.data;
        if (data.message) {
          throw data.message;
        } else {
          throw data;
        }
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }
      console.log(error.config);
    });
}

async function createTransactionIncBillingAddress(payload) {
  return await axios
    .post(baseUrl + `payment/createTransaction`, { ...payload },config)
    .then((response) => {
      return response.data;
    }).catch((error) => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // console.log(error.response.data);
        // console.log(error.response.status);
        // console.log(error.response.headers);
        const data = error.response.data;
        if (data.message) {
          throw data.message;
        } else {
          throw data;
        }
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }
      console.log(error.config);
    });
}